// extracted by mini-css-extract-plugin
export default {"citationLink":"Citation_citationLink__Kowxb","citationContainer":"Citation_citationContainer__oeZ1o"};